import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import { CoursesRedux, CoursesTypes } from '../Redux/CoursesRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

const coursesCrudObservable = createCRUDObservable({
  mainRedux: CoursesRedux,
  reduxPath: 'courses',
  dataHandlers: {
    get: response => response.data.data,
  },
})

const seningPersonEpic = (action$, store, { Api }) =>
  action$.ofType(CoursesTypes.sendPersonRequest)
    .mergeMap(({ data }) => (
      Observable
        .fromPromise(Api.courses.sendingPerson(data)
          .then(result => result)
          .catch(error => error))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [notificationFail(result.error)]
          }
          return [
            notificationSuccess('Persona Agregada Exitosa'),
          ]
        })
    ))



export const coursesObservers = Object.assign({}, coursesCrudObservable.observers, {})

export const coursesEpic = combineEpics(
  coursesCrudObservable.epic,
  seningPersonEpic
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CoursesObservable.js